import { ReactNode, useState } from "react";
import { FilterActions } from "./FilterActions.tsx";
import { toggleListValue } from "./toggleListValue.ts";

export type CheckboxListOption<Value extends string> = {
  value: Value;
  label: ReactNode;
};

export function CheckboxList<Value extends string>({
  options,
  selected,
  onToggle,
}: {
  options: CheckboxListOption<Value>[];
  selected: Value[];
  onToggle: (value: Value) => void;
}) {
  return (
    <div className="flex flex-col gap-1">
      {options.map((option) => (
        <label
          key={option.value}
          className="flex cursor-pointer items-center gap-2 rounded-md px-1 py-1 text-sm text-gray-700 hover:bg-gray-50"
        >
          <input
            type="checkbox"
            checked={selected.includes(option.value)}
            onChange={() => onToggle(option.value)}
            className="w-4 h-4 shrink-0 accent-primary"
          />
          {option.label}
        </label>
      ))}
    </div>
  );
}

export function CheckboxListFilter<Value extends string>({
  options,
  value,
  onApply,
  close,
}: {
  options: CheckboxListOption<Value>[];
  value: Value[];
  onApply: (values: Value[]) => void;
  close: () => void;
}) {
  const [selected, setSelected] = useState(value);
  const apply = (values: Value[]) => {
    onApply(values);
    close();
  };

  return (
    <div className="flex flex-col gap-1 px-2">
      <CheckboxList
        options={options}
        selected={selected}
        onToggle={(toggled) =>
          setSelected((current) => toggleListValue(current, toggled))
        }
      />
      <FilterActions
        canClear={value.length > 0}
        onClear={() => apply([])}
        onApply={() => apply(selected)}
      />
    </div>
  );
}
